import React, { Fragment } from "react";
import useColors from "../hooks/useColors";
import { mergeSxStyles } from "../utilities/functions";
import { Chip as MuiChip } from "@mui/material"
import Typography from "./Typography"
import { useTheme } from "../libraries/material/styles";

export const OUTLINED = "outlined";
export const CONTAINED = "contained";

const createStyles = ({ border, background, text, variant }) => {
  let styles = [];
  if (variant === OUTLINED) {
    styles.push({
      borderColor: border,
      backgroundColor: background,
      color: text,
    });
  } else {
    styles.push({
      backgroundColor: background,
      color: text,
    });
  }
  return styles;
}

const Chip = React.forwardRef((props, ref) => {
  const {
    srOnlyPrimary,
    primary,
    secondary,
    color,
    variant: vt,
    sx,
    invert,
    label,
    ...rest
  } = props;
  const theme = useTheme()
  const colorKeys = Object.keys(theme.palette.colors)
  const useCustomColors = primary || secondary || srOnlyPrimary || colorKeys.includes(color)
  const variant = vt ?? (srOnlyPrimary ? OUTLINED : CONTAINED) ?? CONTAINED;
  const colorValues = useColors({ color, invert });
  const sxStyles = useCustomColors ? mergeSxStyles(
    createStyles({
      ...(colorValues ?? {}),
      variant,
    }),
    sx
  ) : sx
  const allowColor = color && [
    'default',
    'primary',
    'secondary',
    'error',
    'info',
    'success',
    'warning'
  ].includes((color ?? "").toLowerCase())

  let chipLabel = label;
  if(!chipLabel) {
    if (srOnlyPrimary) {
      chipLabel = (
        <Fragment>
          <Typography variant="srOnly">{primary}</Typography>
          {secondary}
        </Fragment>
      );
    } else if (primary) {
      chipLabel = secondary ? (
        <Fragment>
          {primary}: <strong>{secondary}</strong>
        </Fragment>
      ) : (
        <Fragment>{primary}</Fragment>
      );
    }
  }

  return (
    <MuiChip
      color={allowColor ? color : undefined}
      ref={ref}
      variant={variant}
      label={chipLabel}
      sx={sxStyles}
      {...rest}
    />
  );
})

export default Chip
